module.exports = __webpack_public_path__ + "media/images/emblems/Ergisch_Wappen-bba67a5c8494c10ec7a23c494f3e0575.png";